module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('listar-sla', {
    attrs: {
      "refresh_componentes": this.$store.state.refreshComponente.refreshComponente
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33489cbf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sla/IndexSla.vue
// module id = 973
// module chunks = 1